/**
 * Build configuration. Kept as a plain module (no import.meta.env) so the
 * same code runs under Vite, tests and any future bundler.
 */
export const config = {
  /** 'mock' = frontend-only prototype on IndexedDB. 'supabase' = production adapters (not yet implemented). */
  backend: 'mock' as 'mock' | 'supabase',
  /** Shows the Prototype panel, demo account switcher and reset control. */
  prototypeMode: true,
  appName: 'Edri Family',
  appNameHe: 'משפחת אדרי',
  /** Days a fresh memory dot takes to settle to its permanent size. */
  memoryDotFreshDays: 14,
};
